import { createAction, createSlice } from "@reduxjs/toolkit";

const unsubscribeSlice = createSlice({
  name: "unsubscribe",
  initialState: { data: {}, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = unsubscribeSlice;
const unsubscribeAction = createAction(name);

export {
  unsubscribeAction,
  actions as unsubscribeActions,
  reducer as unsubscribeReducer,
};
